/**
 * ControlPlaneService - minimal client for control plane endpoints
 */
import Config from '../core/Config.js';

function base() {
  return (Config.CONTROL_PLANE && Config.CONTROL_PLANE.BASE) || '';
}

function orgHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const org = Config.CONTROL_PLANE?.ORG_ID;
    if (org) headers['x-org-id'] = org;
  } catch (_) {}
  return headers;
}

async function request(path, init = {}) {
  const b = base();
  if (!b) throw new Error('Control plane base not configured');
  const url = `${b.replace(/\/$/,'')}${path}`;
  const res = await fetch(url, init);
  if (!res.ok) throw new Error(`${init.method || 'GET'} ${path} -> ${res.status}`);
  if (res.status === 204) return null;
  return await res.json();
}

export const ControlPlaneService = {
  async postUsageEvents(events = []) {
    if (!base() || !Array.isArray(events) || events.length === 0) return { accepted: 0 };
    try {
      return await request('/usage/events', {
        method: 'POST',
        headers: orgHeaders(),
        body: JSON.stringify({ events })
      });
    } catch (_) { return { accepted: 0 }; }
  },
  async getUsageSummary(plan) {
    if (!base()) return null;
    try {
      const q = plan ? `?plan=${encodeURIComponent(plan)}` : '';
      return await request(`/usage/summary${q}`, { method: 'GET', headers: orgHeaders() });
    } catch (_) { return null; }
  },
  async getOrgSettings(orgId) {
    if (!base() || !orgId) return {};
    try {
      return await request(`/orgs/${encodeURIComponent(orgId)}/settings`, { method: 'GET', headers: orgHeaders() });
    } catch (_) { return {}; }
  },
  async getPromptPacks({ workspaceId } = {}) {
    if (!base()) return { items: [] };
    const q = workspaceId ? `?workspaceId=${encodeURIComponent(workspaceId)}` : '';
    try { return await request(`/prompt-packs${q}`, { method: 'GET', headers: orgHeaders() }); } catch(_) { return { items: [] }; }
  },
  async getWorkspaceSettings(workspaceId) {
    if (!base() || !workspaceId) return {};
    try {
      return await request(`/workspaces/${encodeURIComponent(workspaceId)}/settings`, { method: 'GET', headers: orgHeaders() });
    } catch (_) { return {}; }
  }
};

export default ControlPlaneService;
